import { stepperAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  indicator: {
    '&[data-status=incomplete]': {
      color: 'surface.outlineVariant',
      bgColor: 'transparent',
      borderColor: 'surface.outlineVariant'
    },
    '&[data-status=complete]': {
      color: 'brandPrimary.onPrimary',
      bgColor: 'brandPrimary.primary',
      borderColor: 'brandPrimary.primary'
    },
    '&[data-status=active]': {
      color: 'brandPrimary.onPrimary',
      bgColor: 'brandPrimary.primary',
      borderColor: 'brandPrimary.primary'
    }
  },
  separator: {
    '&[data-status=incomplete]': {
      bgColor: 'surface.outlineVariant'
    },
    '&[data-status=complete]': {
      bgColor: 'brandPrimary.primary'
    },
    '&[data-status=active]': {
      bgColor: 'surface.outlineVariant'
    }
  },
  title: {
    '&[data-status=incomplete]': {
      color: 'surface.outlineVariant'
    }
  }
});

export const stepperTheme = defineMultiStyleConfig({ baseStyle });
